import React, { FC, memo, MouseEvent } from "react";
import { ButtonColor, ButtonSize, ButtonVariant } from "enums/Button";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/Button/Button";
import { PlaceholderIcon, Wrapper } from "../../../../styles/placeholderStyles";
import placeholderIcon from "../../images/storage-placeholder.svg";
import { ButtonsWrapper, Message } from "./SearchPlaceholder.styles";

interface SearchPlaceholderProps {
  handleReset: (event: MouseEvent) => void;
}

const SearchPlaceholder: FC<SearchPlaceholderProps> = ({ handleReset }) => {
  const { t } = useTranslation("common");

  return (
    <Wrapper>
      <PlaceholderIcon
        src={placeholderIcon}
        alt={t("parcels.placeholderIcon")}
      />
      <Message>{t("parcels.search.found")}</Message>
      <ButtonsWrapper>
        <Button
          onClick={handleReset}
          size={ButtonSize.Large}
          color={ButtonColor.Primary}
          variant={ButtonVariant.Filled}
        >
          {t("parcels.search.tryAnotherSearch")}
        </Button>
        <Button
          onClick={handleReset}
          size={ButtonSize.Large}
          color={ButtonColor.Primary}
          variant={ButtonVariant.Bordered}
        >
          {t("parcels.search.dismiss")}
        </Button>
      </ButtonsWrapper>
    </Wrapper>
  );
};

export default memo(SearchPlaceholder);
